import { AlertOctagon, AlertTriangle, CheckCircle2 } from 'lucide-react';

// Colores y textos de los tres estados, iguales en toda la app (asistente,
// historial, incidentes, reportes). Alerta es ámbar y falla es rojo: en una
// herramienta de seguridad no pueden verse como dos grises parecidos.
// El PDF usa ESTADO_RGB; la pantalla, las clases de Tailwind (tokens de
// vls-tokens.css: success, warning, error).

export const ESTADO_LABEL = { aprobado: 'Aprobado', alerta: 'Alerta', falla: 'Falla' };

// Píldora o chip: fondo suave, texto y borde del estado.
export const ESTADO_PILL = {
  aprobado: 'bg-success/10 text-success border-success/30',
  alerta: 'bg-warning/15 text-warning-foreground border-warning/50',
  falla: 'bg-error/10 text-error border-error/40',
};

// Botón o tarjeta marcada (estado seleccionado): fondo lleno.
export const ESTADO_SOLIDO = {
  aprobado: 'bg-success text-success-foreground border-success',
  alerta: 'bg-warning text-warning-foreground border-warning',
  falla: 'bg-error text-error-foreground border-error',
};

// Fila o tarjeta de una lista con ese estado: realce lateral sin saturar.
export const ESTADO_FILA = {
  aprobado: '',
  alerta: 'bg-warning/5 border-l-4 border-l-warning',
  falla: 'bg-error/5 border-l-4 border-l-error',
};

export const ESTADO_RGB = {
  aprobado: [22, 163, 74],
  alerta: [245, 158, 11],
  falla: [220, 38, 38],
};

// Ícono de cada estado, el mismo en toda la app (falla = octágono con !).
// El color nunca va solo: píldoras y botones llevan siempre ícono y texto.
export const ESTADO_ICONO = { aprobado: CheckCircle2, alerta: AlertTriangle, falla: AlertOctagon };
